// default pagination config
export const pagination = {
  /** number of items to skip. default is `10` */
  skip: 0,
  /** number of items to retrieve. default is `10` */
  limit: 10,
  /** the maximum of retrieved docs in one request */
  maxLimit: 1000,
} as const;
